import VueSelect from 'vue-select';

export default {
  components: {
    VueSelect,
  },

  computed: {
    autocompleteConfig() {
      const config = {
        clearable: true,
        limit: this.options.length,
        noDrop: this.hideDropdown,
      };

      // Can we allow multiple selections?
      if (this.question.selectedQuantity > 1) {
        // By default fieldValue is null so safen this up by converting to null
        const safeFieldValue = Array.isArray(this.fieldValue) ? this.fieldValue : [];

        config.multiple = true;
        config.selectable = () => (safeFieldValue.length < this.question.selectedQuantity);
      }

      return config;
    },
  },

  data() {
    return {
      hideDropdown: true,
    };
  },

  methods: {
    // TODO isnt there a built in vue select way of doing this - DL
    setSelected(selectedValue) {
      let formattedValue = null;

      if (this.autocompleteConfig.multiple) {
        formattedValue = selectedValue.map((value) => this.formatSelectedValue(value));
      } else {
        formattedValue = this.formatSelectedValue(selectedValue);
      }

      this.$emit('change', formattedValue);
    },

    formatSelectedValue(value) {
      return (typeof value === 'object' && value !== null)
        ? value.id
        : value;
    },

    setShowDropdown() {
      this.hideDropdown = false;
    },
  },
};
